export const microsoftLoginKey = ["microsoft-login"]
export const auth0LoginKey = ["auth0-login"]

export const auth0LoginKeys = {
  login: ["auth0-login"],
  signup: (email?: string, signup = true) => ["auth0-signup", { email, signup }],
}

export const fabricKeys = {
  all: ["fabrics"] as const,
  lists: () => [...fabricKeys.all, "list"] as const,
  list: (params: unknown) => [...fabricKeys.lists(), params] as const,
  details: () => [...fabricKeys.all, "details"] as const,
  detail: (id?: string | number) => [...fabricKeys.details(), id] as const,
}

export const fabricGroupKeys = {
  all: ["fabricGroups"] as const,
  lists: () => [...fabricGroupKeys.all, "list"] as const,
  list: (params: unknown) => [...fabricGroupKeys.lists(), params] as const,
  details: () => [...fabricGroupKeys.all, "details"] as const,
  detail: (id?: string | number) => [...fabricGroupKeys.details(), id] as const,
}
